import { Skeleton, Space } from "antd";

import { BdsContentHeader, BdsLayout } from "@buildertrend/components";

import "./SpecificationViewer.less";

interface ISpecificationViewerSkeletonProps {
    useMobileLayout?: boolean;
    showBackButton?: boolean;
}

export function SpecificationViewerSkeleton({
    useMobileLayout = false,
}: ISpecificationViewerSkeletonProps) {
    return (
        <div
            className={`specification-viewer ${useMobileLayout ? "mobile-layout" : ""}`}
            data-testid="specification-viewer-skeleton"
        >
            <BdsLayout displayType="HCF" useMaxWidth>
                {/* Header skeleton */}
                <BdsContentHeader
                    id="SpecificationViewerHeaderSkeleton"
                    testid="SpecificationViewerHeaderSkeleton"
                    title={<Skeleton.Input style={{ width: 300, height: 32 }} active />}
                    jobName={useMobileLayout ? "" : undefined}
                    slotTop={
                        <Space direction="horizontal" size="small">
                            <Skeleton.Button active size="small" />
                            <Skeleton.Button active size="small" />
                        </Space>
                    }
                />

                {/* Content skeleton */}
                <Skeleton active paragraph={{ rows: 12 }} />
            </BdsLayout>
        </div>
    );
}
